import { defineComponent, type PropType } from 'vue'
import { ApiTwoTone } from '@ant-design/icons-vue'
import { Tooltip } from 'ant-design-vue'
import styles from './GpyStatus.module.less'
export default defineComponent({
  name: 'GpyStatus',
  props: {
    status: {
      type: Boolean as PropType<boolean>,
      defalut: false
    }
  },
  setup(props, ctx) {
    return () => (
      <div class={styles.box}>
        <div class={props.status ? styles.open : styles.close}>{props.status ? '连接正常' : '连接出错'}</div>
        {!props.status && (
          <Tooltip placement='bottom' title='重连'>
            <ApiTwoTone onClick={() => ctx.emit('reload')} />
          </Tooltip>
        )}
      </div>
    )
  }
})
